import React, { useMemo } from 'react'
import classNames from 'classnames'
import { Button, Tooltip } from '@hose/eui'
import { FeeType, ISpecificationMatched, IFeeTypeMatchedItem } from '../../types/dataMatched'
import AttachmentListItem from './AttachmentListItem'
import RelatedApplicationItem from '../RelatedApplication/RelatedItem'
import { DraggableAttachment, DroppableContainer } from './DragComponents'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import specificationIcons from '../FlowResult/specificationIcons'
import { getParamFromUrl } from '../../utils/tools'
import { showToast } from '../../utils/postmate'
export interface MatchedCardItemProps {
  className?: string
  dataSource: ISpecificationMatched & FeeType
  onChange?: (dataSource: ISpecificationMatched | FeeType, tabItem?: IFeeTypeMatchedItem) => void
  onDelete?: (dataSource: ISpecificationMatched | FeeType, tabItem?: IFeeTypeMatchedItem) => void
  showLabel?: boolean
  isDraggable?: boolean
  deleteDisabled?: boolean
  disableTooltip?: string
  dropProps?: any
  tabItem?: IFeeTypeMatchedItem
}

export const MatchedCardItem: React.FC<MatchedCardItemProps> = (props) => {
  const { 
    className, 
    dataSource, 
    onChange, 
    onDelete, 
    showLabel,
    isDraggable = false,
    deleteDisabled = false,
    disableTooltip,
    tabItem
  } = props

  const isMobile = useMemo(() => {
    return getParamFromUrl('platform') === 'mobile'
  }, [])

  const isHasRequisition = useMemo(() => {
    return Array.isArray(dataSource.requisition) && dataSource.requisition?.length > 0
  }, [dataSource])

  const IconCompo: any = specificationIcons(dataSource?.icon)

  return (
    <div className={classNames('matched-card-item', className)}>
    <div>
      <div className='matched-card-item-header'>
        <div className='matched-card-item-header-title'>
          {dataSource?.icon && (IconCompo ? <IconCompo fontSize={12} style={{ color: dataSource?.color }} /> : <img className="matched-card-item-header-icon" src={dataSource?.icon} alt="" style={{backgroundColor: dataSource?.color, borderRadius: '50%'}}/>)}
          <span>{dataSource?.templateName || dataSource?.name}</span>
          <span className='matched-card-item-header-subname'>{(dataSource as any)?.subname}</span>
        </div>
        <div className="matched-card-item-header-actions">
          {typeof onChange === 'function' && <Button category='text' theme='highlight' size={isMobile ? 'mini' : 'middle'} onClick={() => onChange?.(dataSource, tabItem)}>切换</Button>}
          {typeof onDelete === 'function' && <Button disabled={isMobile ? false : (deleteDisabled || isHasRequisition)} category='text' size={isMobile ? 'mini' : 'middle'} theme='highlight' onClick={() => {
            if(isMobile && (isHasRequisition || deleteDisabled)){
              showToast({
                content: isHasRequisition ? '模板下存在关联申请，不可删除' : disableTooltip
              })
            } else {
              onDelete?.(dataSource, tabItem)
            }
          }}>
            {
              isMobile ? <span>删除</span> : <Tooltip title={isHasRequisition ? '模板下存在关联申请，不可删除' : (disableTooltip || '')}>
              <span>删除</span>
            </Tooltip>
            }
          </Button>}
        </div>
      </div>
      <div className='matched-card-item-content'>
        <div className='matched-card-item-content-section'>
          {showLabel &&<span>附件：</span>}
          {
            isDraggable ? (
              <DroppableContainer 
                itemId={dataSource.uuid}
                className='matched-card-item-content-section-container'
              >
                <SortableContext 
                  items={dataSource.attachments?.map(attachment => attachment.fileKey) || []}
                  strategy={verticalListSortingStrategy}
                >
                  {dataSource.attachments?.length > 0 ? dataSource.attachments?.map(item => (
                    <DraggableAttachment 
                      key={item.fileKey} 
                      attachment={item}
                      parentId={dataSource.uuid}
                    />
                  )) : <span className='matched-card-item-content-section-container-placeholder'>可拖拽文件到此处</span>}
                </SortableContext>
              </DroppableContainer>
            ) : (
              <div className='matched-card-item-content-section-container'>
                {dataSource.attachments?.length > 0 ? dataSource.attachments?.map(item => (
                  <AttachmentListItem 
                    key={item.fileKey} 
                    dataSource={item} 
                  />
                )) : <span className='matched-card-item-content-section-container-placeholder'>可拖拽文件到此处</span>}
              </div>
            )}
        </div>
        {Array.isArray(dataSource.requisition) && dataSource.requisition?.length > 0 && <div className='matched-card-item-content-section'>
          <span>关联申请：</span>
          {
            dataSource.requisition?.map(item => (
              <RelatedApplicationItem key={item.id} {...item} className='related-application-item' />
            ))
          }
        </div>}
        {typeof dataSource.requisition === 'object' && 'id' in dataSource.requisition && <div className='matched-card-item-content-section'>
          <span>关联申请：</span>
          <RelatedApplicationItem key={dataSource.requisition.id} {...dataSource.requisition} className='related-application-item' />
        </div>}
      </div>
    </div>
  </div>

  )
}

export default MatchedCardItem